module.exports = __webpack_public_path__ + "static/img/contant_6.30d7373.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_4/contant_6.jpg
// module id = VbWB
// module chunks = 0